
import { mapGetters } from 'vuex'
import { image, footer} from '../customWhiteLabel'
export default {
  name: 'LayoutDefault',
  head() {
    return {
      title: `Expresso CWB | Certificado Digital ${footer.cidade}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.unidadeInformation.seo?.descricaoPadrao,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.unidadeInformation.seo?.palavrasChavesPadrao,
        },
        {
          name: 'geo.placename',
          content: `${this.unidadeInformation.seo?.endereco.cidade}, ${this.unidadeInformation.seo?.endereco.estado}`,
        },
        {
          name: 'ICBM',
          content: `${this.unidadeInformation.seo?.endereco.geo.latitude}, ${this.unidadeInformation.seo?.endereco.geo.longitude}`,
        },
        { name: 'robots', content: 'index, follow' },
        { name: 'geo.region', content: 'BR-PR' },
        { name: 'revisit-after', content: '7 days' },
        { name: 'theme-color', content: '#045C90' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://senhadigital.com.br/' },
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Senha Digital - Certificados Digitais em Curitiba',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            'Especialistas em e-CPF, e-CNPJ, NFe, e-Jurídico, e-Médico, e-Engenheiro, e-Saúde, CT-e, e-Arquiteto, e-PF, e-PJ, MEI.',
        },
        {
          property: 'og:image',
          content:
            'https://senhadigital.com.br/image-bank/social-senhadigital.webp',
        },
        { property: 'og:site_name', content: 'Senha Digital' },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: '@senhadigital' },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: 'Senha Digital - Certificados Digitais em Curitiba',
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content:
            'Especialistas em e-CPF, e-CNPJ, NFe, e-Jurídico, e-Médico, e-Engenheiro, e-Saúde, CT-e, e-Arquiteto, e-PF, e-PJ, MEI.',
        },
        {
          name: 'twitter:image',
          content:
            'https://senhadigital.com.br/image-bank/social-senhadigital.webp',
        },
      ],
      link: [
        {
          rel: 'preload',
          href: 'https://senhadigital.com.br/image-bank/woman-home-page.webp',
          as: 'image',
        },
        {
          rel: 'shortcut icon',
          href: `${image.favicon}`,
          type: 'image/x-icon',
        },
        { rel: 'icon', href: `${image.favicon}`, sizes: '32x32' },
        { rel: 'icon', href: `${image.favicon}`, sizes: '48x48' },
        { rel: 'icon', href: `${image.favicon}`, sizes: '96x96' },
        { rel: 'icon', href: `${image.favicon}`, sizes: '144x144' },
        { rel: 'icon', href: `${image.favicon}`, sizes: '192x192' },
        { rel: 'apple-touch-icon', href: 'social/ios-icon.png' },
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'AutoBodyShop',
            name: 'Senha Digital',
            description:
              'Especialistas em e-CPF, e-CNPJ, NFe, e-Jurídico, e-Médico, e-Engenheiro, e-Saúde, CT-e, e-Arquiteto, e-PF, e-PJ, MEI.',
            address: {
              '@type': 'PostalAddress',
              streetAddress: this.unidadeInformation?.seo.endereco.logradouro,
              addressLocality: this.unidadeInformation?.seo.endereco.cidade,
              addressRegion: this.unidadeInformation?.seo.endereco.estado,
              postalCode: this.unidadeInformation?.seo.endereco.cep,
              addressCountry: 'BR',
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: Number(
                this.unidadeInformation?.seo.endereco.geo.latitude
              ),
              longitude: Number(
                this.unidadeInformation?.seo.endereco.geo.longitude
              ),
            },
            url: 'https://senhadigital.com.br/',
            telephone: '(41) 1234-5678',
            openingHours: ['Mo-Fr 09:00-18:00'],
            image:
              'https://senhadigital.com.br/image-bank/social-senhadigital.webp',
          }),
        },
        {
          type: 'text/javascript',
          innerHTML: `
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "nnrsl2nokp");
        `,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('unidade', ['configUnit', 'unidadeInformation']),
  },
}
